"use strict";

import "./VehicleHeatmap.css";
import React from "react";
import classnames from "classnames";

import dispatcher from "./../../dispatcher";
import vehicleHeatmapStore from "./../../store/vehicleHeatmaps";
import displayedDetailsStore from "./../../store/displayedDetails";

import vehicleHeatmapUtils from "./../../utils/vehicleHeatmap";

import IntervalEditor from "vwa/components/IntervalEditor";
import ProgressBar from "vwa/components/ProgressBar";
import Button from "vwa/components/Button";
import Checkbox from "vwa/components/Checkbox";
import Form from "vwa/components/Form";
import lang from "vwa/lang";

import EEP from "vfu/EEP";
import shouldComponentUpdate from "vwa/shouldComponentUpdate";

import getVehicleHeatmap from "./../../api/getVehicleHeatmap";

export default class VehicleHeatmap extends React.Component {

	constructor(props){
		super(props);
		this.initState();
		this.eep = new EEP();
		this.setStoreListeners();
	}
	
	initState(){
		this.state = {
			vehicleHeatmapDescriptor: null,
			from: Date.parse( (d => {d.setDate(d.getDate()-14); return d;})(new Date()) ),
			to: Date.now(),
			inProgress: false
		};
	}
	
	setStoreListeners(){
		this.eep.on(vehicleHeatmapStore, "change", vehicleHeatmapDescriptors => this.handleVehicleHeatmapStoreChange(vehicleHeatmapDescriptors));
		this.eep.on(displayedDetailsStore, "change", detailsDescriptor => this.handleDetailsStoreChange(detailsDescriptor));
	}
	
	shouldComponentUpdate(...nexts){
		return shouldComponentUpdate(this, ...nexts);
	}
	
	componentWillUnmount() {
		this.eep.close();
	}
	
	componentDidMount(){
		if(openedDetailsStore.get(this.props.vehicleId).activePage == "heatmap"){
			this.getHeatmapDescriptors();
		}
	}
	
	handleDetailsStoreChange(detailsDescriptor){
		if(detailsDescriptor && detailsDescriptor.id == this.props.vehicleId && vehicleHeatmapUtils.getVisibilityOfHeatmap(this.props.vehicleId) && !this.state.vehicleHeatmapDescriptor){
			this.getHeatmapDescriptors();
		}
	}
	
	handleVehicleHeatmapStoreChange(vehicleHeatmapDescriptors){
		const descriptor = (vehicleHeatmapDescriptors || []).find(e => e.vehicle == this.props.vehicleId);
		if(descriptor){
			this.setState({
				vehicleHeatmapDescriptor: vehicleHeatmapDescriptors[0]
			});
		}
	}
	
	async getHeatmapDescriptors(){
		this.setState({inProgress: true});
		await getVehicleHeatmap(this.props.vehicleId, this.state.from, this.state.to);
		this.setState({inProgress: false});
	}
	
	render(){
		const intervalEditorProps = {
			nullable: false,
			interval: {
				from: this.state.from,
				to: this.state.to
			},
			onChange: interval => {
				this.setState({
					from: interval.from,
					to: interval.to
				});
			}
		}
		
		const noResult = (!this.state.inProgress &&
						   this.state.vehicleHeatmapDescriptor &&
						   this.state.vehicleHeatmapDescriptor.sections &&
						   this.state.vehicleHeatmapDescriptor.sections.length == 0 );
		
		return(
			<div className="VehicleHeatmap">
				<header className="Shadowed">
					<IntervalEditor {...intervalEditorProps} />
					<Button className="Red" disabled={this.state.inProgress} onClick={_ => this.getHeatmapDescriptors()}>{lang.SUBMIT}</Button>
				</header>
				<div className="Content">
					<ProgressBar indeterminate shown={this.state.inProgress} />
					<h1 className={classnames("Message", {"Hidden": !noResult})} >{lang.NO_RESULTS_FOUND}</h1>
					<div className={classnames("CheckboxContainer", {"Hidden": this.state.inProgress || noResult})}>
						<div>
							<label>{lang.ROUTES}</label>
							<Checkbox
								checked={this.state.vehicleHeatmapDescriptor ? this.state.vehicleHeatmapDescriptor.show.routes : false}
								onChange={value => dispatcher.dispatch("showVehicleHeatmapElements", this.props.vehicleId, {routes: value, stops: this.state.vehicleHeatmapDescriptor.show.stops})}
							/>
						</div>
						<div>
							<label>{lang.STOPS}</label>
							<Checkbox
								checked={this.state.vehicleHeatmapDescriptor ? this.state.vehicleHeatmapDescriptor.show.stops : false}
								onChange={value => dispatcher.dispatch("showVehicleHeatmapElements", this.props.vehicleId, {routes: this.state.vehicleHeatmapDescriptor.show.routes, stops: value})}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

VehicleHeatmap.propTypes = {
	vehicleId: React.PropTypes.string
};

VehicleHeatmap.defaultProps = {
	vehicleId: ""
};


// WEBPACK FOOTER //
// ./src/view/VehicleHeatmap/VehicleHeatmap.jsx